(() => {
  if (window.__upsellProductInitialized) return;
  window.__upsellProductInitialized = true;

  const formatMoney = (cents) => `₹ ${(Number(cents || 0) / 100).toLocaleString('en-IN')}`;

  function syncVariant(item, option) {
    const price = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.comparePrice || 0);
    const available = option.dataset.available === 'true';
    const discount = Number(item.closest('.upsell')?.dataset.discount || 0);
    const badgeLabel = item.dataset.upsellBadgeLabel || '';
    const priceElement = item.querySelector('[data-upsell-price]');
    const compareElement = item.querySelector('[data-upsell-compare-price]');
    const badgeElement = item.querySelector('[data-upsell-badge]');
    const button = item.querySelector('[data-upsell-add-btn]');
    const buttonText = item.querySelector('[data-upsell-btn-text]');

    if (!priceElement || !compareElement || !badgeElement || !button || !buttonText) return;

    if (discount > 0) {
      priceElement.textContent = formatMoney(Math.round((price * (100 - discount)) / 100));
      compareElement.textContent = formatMoney(price);
      compareElement.classList.remove('hidden');
      badgeElement.textContent = badgeLabel || `Save ${formatMoney(price - Math.round((price * (100 - discount)) / 100))}`;
      badgeElement.classList.remove('hidden');
    } else if (comparePrice > price) {
      priceElement.textContent = formatMoney(price);
      compareElement.textContent = formatMoney(comparePrice);
      compareElement.classList.remove('hidden');
      badgeElement.textContent = badgeLabel || `Save ${formatMoney(comparePrice - price)}`;
      badgeElement.classList.remove('hidden');
    } else {
      priceElement.textContent = formatMoney(price);
      compareElement.textContent = '';
      compareElement.classList.add('hidden');
      badgeElement.textContent = badgeLabel;
      badgeElement.classList.toggle('hidden', !badgeLabel);
    }

    button.dataset.variantId = option.value;
    button.toggleAttribute('disabled', !available);
    buttonText.textContent = available ? '+ Add' : 'Sold Out';
  }

  function getMiniCart() {
    return document.querySelector('mini-cart');
  }

  function getCartSectionIds() {
    const miniCart = getMiniCart();
    if (!miniCart || typeof miniCart.getSectionsToRender !== 'function') return [];

    return miniCart.getSectionsToRender().map((section) => section.id).filter(Boolean);
  }

  function setAccordionOpen(accordion, isOpen) {
    const toggle = accordion.querySelector('[data-upsell-accordion-toggle]');
    const panel = accordion.querySelector('[data-upsell-accordion-panel]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Close upsell products' : 'Open upsell products');
    accordion.classList.toggle('upsell--collapsed', !isOpen);
    panel.hidden = !isOpen;
    panel.style.height = isOpen ? 'auto' : '0px';
    panel.style.opacity = isOpen ? '1' : '0';
  }

  async function addUpsellProduct(form) {
    const button = form.querySelector('[data-upsell-add-btn]');
    const buttonText = form.querySelector('[data-upsell-btn-text]');
    const variantId = form.querySelector('[data-upsell-variant-id]')?.value;
    if (!button || !buttonText || !variantId) return;

    button.disabled = true;
    button.classList.add('loading');

    try {
      const formData = new FormData(form);
      const sectionIds = getCartSectionIds();
      if (sectionIds.length) formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);

      const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const cart = await response.json();
      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || 'Unable to add this product to the cart.');
      }

      const miniCart = getMiniCart();
      if (!miniCart || typeof miniCart.renderContents !== 'function' || !cart.sections) {
        window.location.assign(window.theme?.routes?.cart_url || '/cart');
        return;
      }

      miniCart.renderContents(cart);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cart } }));
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('loading');
      buttonText.textContent = 'Try again';
      window.setTimeout(() => {
        buttonText.textContent = '+ Add';
      }, 2000);
    }
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-upsell-select]');
    if (!select) return;

    const item = select.closest('[data-upsell-product]');
    if (item) syncVariant(item, select.options[select.selectedIndex]);
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest?.('[data-upsell-accordion-toggle]');
    if (!toggle) return;

    const accordion = toggle.closest('[data-upsell-accordion]');
    if (accordion) setAccordionOpen(accordion, toggle.getAttribute('aria-expanded') !== 'true');
  });

})();
